import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('SIGNUP').plugin(axiosPlugin);

let createUserAction = redux.fetchActionCreate();

let updateUserAction = redux.fetchActionUpdate();

export const TYPES = redux.types;

export const createUser = (data) => createUserAction(`/users`, data);
export const updateUserEmail = (data) => updateUserAction(`/users/me/update-emailunconfirmed`, data);
export const sendEnrollmentEmail = (data) => updateUserAction(`/users/me/send-emailunconfirmed`, data);
export const resetCreateUser = () => redux.actions.reset();

export const signup = redux.reducer();